import { EDITORIAL_TEXTURES, SelectorScenery } from "./BladeSelectorEditorial";
import "../pages/pageAccess.css";

export default function SelectorBackground() {
  return (
    <div className="page-access-background" style={EDITORIAL_TEXTURES}>
      <SelectorScenery />
      <img className="page-access-editorial-art" src={`${process.env.PUBLIC_URL}/redesign/images/redesign/blade_v2/08_system7_header_editorial_overlay.png`} alt="" aria-hidden="true" />
    </div>
  );
}
